import { render } from "./RequiredItems.vue?vue&type=template&id=0ae46634&scoped=true"
import script from "./RequiredItems.vue?vue&type=script&lang=js"
export * from "./RequiredItems.vue?vue&type=script&lang=js"

import "./RequiredItems.vue?vue&type=style&index=0&id=0ae46634&scoped=true&lang=scss"
import "./RequiredItems.vue?vue&type=style&index=1&id=0ae46634&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ae46634"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QList from 'quasar/src/components/item/QList.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QChip,QSeparator,QBtnGroup,QBtnToggle,QTooltip,QSelect,QIcon,QItem,QItemSection,QItemLabel,QSpinnerDots,QSpace,QDialog,QCard,QCardSection,QInput,QPopupProxy,QDate,QSpinner,QCheckbox,QList,QField});qInstall(script, 'directives', {ClosePopup});
